import React from 'react'
import MappingTabs from './MappingTabs'

const ExpediaTab = () => <MappingTabs />

export default ExpediaTab



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/ExpediaTab.js